import React from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { myEpikBaseURL, unifiedBaseURL } from '../lib/api/api';

const callApi = async (endpoint, method, body, isMyEpik) => {
  const url = `${isMyEpik ? myEpikBaseURL : unifiedBaseURL()}${
    process.env.REACT_APP_UNIFIED_API_VERSION
  }/${endpoint}`;
  const token = localStorage.getItem('jwtToken') || null;
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  switch (method) {
    case 'POST':
      return await axios.post(url, body, {
        headers,
      });
    case 'PUT':
      return await axios.put(url, body, {
        headers,
      });
    case 'PATCH':
      return await axios.patch(url, body, {
        headers,
      });
    case 'DELETE':
      return await axios.delete(url, {
        headers,
      });
    default:
      throw new Error(`Method ${method} is not supported.`);
  }
};

export function useUnifiedMutate(isMyEpik) {
  const [isLoading, setIsLoading] = React.useState(false);
  const [results, setResults] = React.useState();

  const mutate = async (endpoint, method, body) => {
    try {
      setIsLoading(true);

      const apiResponse = await callApi(endpoint, method, body, isMyEpik);

      setResults(apiResponse.data);

      toast.success('Success! Data updated.');
      return apiResponse.data;
    } catch (err) {
      toast.error(err?.response?.data || err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, results, mutate };
}
